var apiEndpoint;
window.YMM = {}
window.initFirstTime = false;
window.ymm_globalData = [];



function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function processData() {
    for (let i = 0; i < window.ymm_globalData.length; i++) {
        var x = window.ymm_globalData[i].label;
        var x_arr = x.split('|')
        if (x_arr.length > 2) {
            if (!window.YMM[x_arr[0]]) window.YMM[x_arr[0]] = {}
            if (!window.YMM[x_arr[0]][x_arr[1]]) window.YMM[x_arr[0]][x_arr[1]] = {}
            if (!window.YMM[x_arr[0]][x_arr[1]][x_arr[2]]) window.YMM[x_arr[0]][x_arr[1]][x_arr[2]] = {}
            if (!window.YMM[x_arr[0]][x_arr[1]][x_arr[2]][x_arr[3]]) window.YMM[x_arr[0]][x_arr[1]][x_arr[2]][x_arr[3]] = {}
            window.YMM[x_arr[0]][x_arr[1]][x_arr[2]][x_arr[3]][x_arr[4]] = true;
        }
    }
    sessionStorage.setItem('ymmData', JSON.stringify(window.YMM));
}

var updateValue = () => {
    if (loadingContainer)
        loadingContainer.style.display = 'none';
    var ymmData = Cookies.get('ymm');
    if (ymmData) {
        myVehicleDiv.style.display = '';
        ymmForm.style.display = 'none';
    } else {
        myVehicleDiv.style.display = 'none';
        ymmForm.style.display = '';
    }

    let current_vehice = myVehicleDiv.querySelector('#current_vehice')
    if (current_vehice)
        current_vehice.innerHTML = decodeURIComponent(ymmData).replace('null', 'ANY').replace('-1337usf', 'ANY')
}

function initApp() {
    apiEndpoint = usf.settings.searchSvcUrl + "facets?name=" + filterYMMName + "&apiKey=" + usf.settings.siteId + "&sort=label&filter=id,label";

    var count = 0;

    makeChoice.disable();
    engineChoice.disable();
    yearChoice.disable();
    driveChoice.disable();

    var reloadSR = () => {
        if (window.usf && window.usf.query && window.usf.query.update) {
            var oldQ = usf.query.get('q', '')
            window.usf.query.update({
                q: -6969696969
            }, [], {
                force: true
            });

            window.usf.query.update({
                q: oldQ
            }, [], {
                force: true
            });
            usf.search.refresh()
        }
    }

    modelChoice.passedElement.element.addEventListener( 
        'showDropdown',
        async function(event) {
                if (window.initFirstTime) return true;

                var requests = [];

                const response = await fetch(apiEndpoint + '&skip=0&take=1');
                const countFacets = await response.json();
                count = countFacets && countFacets.pagination && countFacets.pagination.totalCount ? countFacets.pagination.totalCount : 0;

                var sessionData = sessionStorage.getItem('ymmData');
                let ssCount = sessionStorage.getItem('ymmDataLength');
                if (sessionData !== null && IsJsonString(sessionData) && ssCount == count) {
                    console.log("case1")
                    window.YMM = JSON.parse(sessionData);
                    window.initFirstTime = true;
                    updateFirstDropdown()
                    return;
                }
                for (i = 0; i < parseInt(count / 1000) + 1; i++) {
                    let r = await fetch(`${apiEndpoint}&skip=${i*1000}&take=1000`);
                    let rJson = await r.json();
                    if (rJson && typeof rJson == "object" && rJson['data']) {
                        window.ymm_globalData = [...window.ymm_globalData, ...rJson['data']]
                    }
                }

                sessionStorage.setItem('ymmDataLength', count);
                processData()
                updateFirstDropdown()

                window.initFirstTime = true;
            },
            false,
    );

    modelChoice.passedElement.element.addEventListener(
        'change',
        function(event) {
            let v = event.detail.value;
            let arr = [{
                'value': '',
                'label': 'Model',
                'placeholder': true,
                selected: true
            }];
            if (v && v != -1) {
                makeChoice.enable();
            } else {
                makeChoice.disable();
            }
            for (const key in window.YMM[v]) {
                var value = window.YMM[v][key];
                arr.push({
                    value: key,
                    label: key
                })
            }
            makeChoice.clearStore();
            makeChoice.setChoices(
                arr,
                'value',
                'label',
                false,
            );

        },
        false,
    );

    makeChoice.passedElement.element.addEventListener(
        'change',
        function(event) {
            let arr = [{
                'value': '',
                'label': 'Engine',
                'placeholder': true,
                selected: true
            }];
            var makeValue = event.detail.value;
            var modelValue = modelChoice.getValue(true) + ' ';
            var models = window.YMM[modelValue][makeValue];
            var v = modelValue;
            if (v && v != -1) {
                engineChoice.enable();
            } else {
                engineChoice.disable();
            }

            for (const key in models) {
                var value = models;
                arr.push({
                    value: key,
                    label: key
                })
            }

            // console.log("models : ", models);
            // console.log("Object.keys(models).length : ", Object.keys(models).length);
            // console.log("models[''] : ", models[''])
            engineChoice.clearStore();
            engineChoice.setChoices(
                arr, 
                'value',
                'label',
                false,
            );
        },
        false,
    );

    engineChoice.passedElement.element.addEventListener(
        'change',
        function(event) {
            let arr = [{
                'value': '',
                'label': 'Year',
                'placeholder': true,
                selected: true
            }];
            var engineValue = event.detail.value;
            var makeValue = ' ' + makeChoice.getValue(true) + ' ';
            var modelValue = modelChoice.getValue(true) + ' ';
            var years = window.YMM[modelValue][makeValue][engineValue];
            var v = engineValue;
            if (v && v != -1) {
                yearChoice.enable();
            } else {
                yearChoice.disable();
            }

            for (const key in years) {
                var value = years;
                arr.push({
                    value: key,
                    label: key
                })
            }

            // console.log("years : ", years);
            // console.log("Object.keys(models).length : ", Object.keys(models).length);
            // console.log("models[''] : ", years[''])
            yearChoice.clearStore();
            yearChoice.setChoices(
                arr, 
                'value',
                'label',
                false,
            );
        },
        false,
    );

    yearChoice.passedElement.element.addEventListener(
          'change',
          function(event) {
              let arr = [{
                  'value': '',
                  'label': 'Drive',
                  'placeholder': true,
                  selected: true
              }];
              var yearValue = event.detail.value;
              var modelValue = modelChoice.getValue(true) + ' ';
              var makeValue = ' ' + makeChoice.getValue(true) + ' ';
              var engineValue = ' ' + engineChoice.getValue(true) + ' ';
              var drives = window.YMM[modelValue][makeValue][engineValue][yearValue];
              console.log(window.YMM[modelValue][makeValue][engineValue])
              console.log(window.YMM[modelValue][makeValue][engineValue])
              var v = yearValue;
              if (v && v != -1) {
                  driveChoice.enable();
              } else {
                  driveChoice.disable();
              }
  
              for (const key in drives) {
                  var value = drives;
                  arr.push({
                      value: key,
                      label: key
                  })
              }
              console.log(arr)
  
              driveChoice.clearStore();
              driveChoice.setChoices(
                  arr, 
                  'value',
                  'label',
                  false,
              );
          },
          false,
      );



    const updateFirstDropdown = () => {
        let arr = [],
            exist = false;
        modelChoice.clearChoices();
        modelChoice.setChoices(
            [{
                value: '',
                'label': 'Loading ...',
                disabled: true
            }],
            'value',
            'label',
            false,
        );
        for (let k in window.YMM) {
            var v = window.YMM[k];
            arr.push({
                value: k,
                label: k
            })
            exist = true;
        }

        if (exist) {
            modelChoice.clearChoices();
            modelChoice.setChoices(
                arr,
                'value',
                'label',
                false,
            );
        }
    }

    updateValue()
    updateFirstDropdown()

    document.querySelector('.change_vehicle').addEventListener('click', function() {
        myVehicleDiv.style.display = 'none';
        ymmForm.style.display = '';
    }, false);

    document.querySelector('.clear_vehice').addEventListener('click', function() {
        Cookies.remove('ymm')
        myVehicleDiv.style.display = 'none';
        ymmForm.style.display = '';
        reloadSR()
    }, false);
    document.querySelector('form.ymm-form').addEventListener("submit", function(evt) {
        evt.preventDefault();
        var year = yearChoice.getValue(true),
            make = makeChoice.getValue(true),
            engine = engineChoice.getValue(true),
            model = modelChoice.getValue(true),
            drive = driveChoice.getValue(true);

        if (year == -1 || !year || make == -1 || !make || model == -1 || !model || !engine || engine == -1 || !drive || drive == -1) {
            Toastify({
                text: "You must fill in all of the fields",
                duration: 3000,
                destination: "https://github.com/apvarun/toastify-js",
                newWindow: true,
                close: true,
                gravity: "top", // `top` or `bottom`
                position: "right", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
                style: {
                    background: "linear-gradient(to right, #ff5f6d, #ffc371)"
                }
            }).showToast();
        } else {
            Cookies.set('ymm', `${model} | ${make} | ${engine} | ${year} | ${drive}`); 
            if (window.usfTemplate == 'search') {
              updateValue();
              reloadSR();
            } else {
              window.location = '/search'
            }
            
        }
      
    });
}

let loadingContainer = null,
    myVehicleDiv = null,
    ymmForm = null,
    modelSelect = null,
    makeSelect = null,
    engineSelect = null,
    yearSelect = null,
    driveSelect = null,
    modelChoice, makeChoice, engineChoice, yearChoice, driveChoice;
window.addEventListener('load', function() {
    if (window.usfTemplate != 'search') {
      Cookies.remove('ymm') 
    }
    loadingContainer = document.querySelector('.loading-container');
    myVehicleDiv = document.getElementById('my_vehicle');
    ymmForm = document.querySelector('.ymm-form');
    modelSelect = document.querySelector('#modelSelect');
    makeSelect = document.querySelector('#makeSelect');
    engineSelect = document.querySelector('#engineSelect');
    yearSelect = document.querySelector('#yearSelect'); 
    driveSelect = document.querySelector('#driveSelect'); 

    modelChoice = new Choices(modelSelect);
    makeChoice = new Choices(makeSelect);
    engineChoice = new Choices(engineSelect);
    yearChoice = new Choices(yearSelect);
    driveChoice = new Choices(driveSelect);
    initApp()
})